module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "line",
    attrs: {
      "id": "blueline1"
    }
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "Images/blueline.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Well-intentioned people of pallor went seamlessly from not seeing color to being allies. Being part of the problem was never considered. And, really, “ally” was fine for a while. It was aspirational. But now “I’m an ally” is the “Don’t hurt me!” of our time. Don’t nobody want you, Karen. You can keep that to yourself.")]), _vm._v(" "), _c('p', {
    staticClass: "line",
    attrs: {
      "id": "blueline2"
    }
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "Images/blueline.jpg"
    }
  })])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2c31608e","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Text/chap2.vue
// module id = 75
// module chunks = 0